import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Stack } from "expo-router";

export default function LoginScreenLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        header: (props) => <ScreenHeader title="auth.login.headerTitle" {...props} />,
      }}
    />
  );
}
